/*
  COTANTIN コレクションの商品一覧（sections/cotantin-coll-main.liquid）。
  種類のタブ・並び替え・ページ送りを、ページを読み直さずに切り替える。
  Shopify の Section Rendering API（?section_id=）でこのセクションだけを取り直し、中身を差し替える。
  URL は history.pushState で書き換えるので、戻る・進む・共有・再読み込みでも同じ状態になる。
  取得に失敗したときは、ふつうにページを移動する（壊れない）。
*/
(function () {
  var controller = null;

  function root() {
    return document.querySelector('[data-cc-main]');
  }

  function scrollIfNeeded(main) {
    // ツールバーが画面より上に隠れているとき（ページ送り・下までスクロールしてからの並び替え）だけ戻す
    var tools = main.querySelector('.cc-tools') || main;
    var header = document.querySelector('.shopify-section--header, [data-section-type="header"], header');
    var offset = header ? header.getBoundingClientRect().height : 0;
    var top = tools.getBoundingClientRect().top;
    if (top < offset) {
      window.scrollTo({ top: window.scrollY + top - offset, behavior: 'smooth' });
    }
  }

  function load(url, push) {
    var main = root();
    if (!main) { window.location.href = url; return; }

    var target = new URL(url, window.location.href);
    target.searchParams.delete('section_id');
    var fetchUrl = new URL(target.toString());
    fetchUrl.searchParams.set('section_id', main.dataset.sectionId);

    if (controller) controller.abort();
    controller = new AbortController();
    main.classList.add('is-loading');
    main.setAttribute('aria-busy', 'true');

    var tabs = main.querySelector('.cc-tabs__list');
    var tabsScroll = tabs ? tabs.scrollLeft : 0;

    fetch(fetchUrl.toString(), { signal: controller.signal, credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-cc-main]');
        if (!next) throw new Error('section not found');
        main.innerHTML = next.innerHTML;
        main.classList.remove('is-loading');
        main.removeAttribute('aria-busy');

        // スマホのタブの横スクロール位置を保つ（押したタブが見えなくならないように）
        var newTabs = main.querySelector('.cc-tabs__list');
        if (newTabs) {
          newTabs.scrollLeft = tabsScroll;
          var current = newTabs.querySelector('.is-current');
          if (current) {
            var l = current.offsetLeft - newTabs.offsetLeft;
            if (l < newTabs.scrollLeft || l + current.offsetWidth > newTabs.scrollLeft + newTabs.clientWidth - 40) {
              newTabs.scrollLeft = Math.max(0, l - 16);
            }
          }
        }

        if (push) history.pushState({ ccMain: true }, '', target.toString());
        scrollIfNeeded(main);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        window.location.href = target.toString();
      });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-cc-main] .cc-tab, [data-cc-main] .pagination a');
    if (!link || !link.href) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return; // 新しいタブで開く操作はそのまま
    event.preventDefault();
    load(link.href, true);
  });

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-cc-main] [data-cc-sort]');
    if (!select) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    load(url.toString(), true);
  });

  window.addEventListener('popstate', function () {
    if (root()) load(window.location.href, false);
  });
})();
